const ERROR_MESSAGES = {
	INIT_FAILED: 'HubSpot Load Form: Initialization failed',
};

/**
 * Initialize HubSpot Form Load
 * @returns {void}
 */
export const initializeHubSpotForm = () => {
	// Only run if the container exists
	var formContainer = document.querySelector('.form-body');
	if (formContainer && typeof hbspt !== 'undefined') {
		// Prevent double-loading
		// grab the form id from the data attribute
		var formId = formContainer.attributes['data-form'] ? formContainer.attributes['data-form'].value : 'n/a';
		if (!formContainer.dataset.hubspotLoaded) {
			hbspt.forms.create({
				portalId: '20675274',
				formId: formId,
				region: 'na1',
				target: '.form-body',
			});
			formContainer.dataset.hubspotLoaded = 'true';
		}
	}
};
